import Tween from 'tween';

/**
 * Foreground visualization of the data that model contains.
 */
export default class View extends PIXI.Container
    {
    /**
     * Initialize
     *
     * @param  {Object}  size    The size
     * @param  {Object}  images  The images
     */
    constructor(size, images)
    {
        super();
        this.size = size;
        this.url = images.star;

        this.addStar(0);
        this.addStar(2);
        this.addStar(3);
        this.addStar(4);
    }

    /**
     * Called on resize
     *
     * @param  {Object}  size  The size data
     */
    resize(size)
    {
        this.size = size;
    }

    /**
     * Adds a star.
     *
     * @param  {Number}  delay  The time before adding the star
     */
    addStar(delay)
    {
        const star = new PIXI.Sprite.fromImage(this.url);

        star.x = Math.floor(Math.random() * this.size.width);
        star.y = Math.floor(Math.random() * this.size.height);
        star.anchor.set(0.5);
        star.scale.set(1);
        star.alpha = 0;

        this.addChild(star);

        const duration = 0.7;

        const fade = {
            alpha: 1,
            repeat: 1,
            yoyo: true,
            delay,
            onComplete: () =>
            {
                star.removeSelf();
                this.addStar(0);
            },
        };

        const rotate = {
            rotation: 6,
            ease: Linear.easeNone,
            delay,
        };

        const scale = {
            x: 1.5,
            y: 1.5,
            repeat: 1,
            yoyo: true,
            delay,
        };

        Tween.to(star, duration, fade);
        Tween.to(star, duration * 2, rotate);
        Tween.to(star.scale, duration, scale);
    }
}




// WEBPACK FOOTER //
// ./themes/fq/view/background-view.js